import React, { useContext, useState, useEffect } from 'react';
import { Checkbox, Tooltip } from '@mui/material';
import { RowDataContext, RestrictionsStateContext } from '../contexts';
import { allRatePlanHasRecAccepted, anyRatePlanHasOverriden, isAnyRestrictionsAltered } from '../functions';
import icons from '../svgIcons';
import moment from 'moment';
import { useDispatch } from 'react-redux';

export const ToggleRoomTypeCurrentRec = ({ roomType, isPastDate }) => {
  const dateRowData = useContext(RowDataContext);
  const restrictionsState = useContext(RestrictionsStateContext);
  const buckets = dateRowData?.data?.buckets;
  const [checkedVal, setCheckedVal] = useState(false);
  const compRef = React.useRef({ checkedCount: [] });
  const dispatch = useDispatch();

  const handleChange = (e) => {
    e.stopPropagation();
    const checked = e.target.checked;
    // const d = dateObj;
    buckets?.forEach((bucket, i) => {
      // bucket.rec_accepted = true;
      bucket.rooms_summary.forEach(roomData => {
        if (roomData.room_type_code === roomType) roomData.curr_user_action = checked ? 'recommended_accepted' : '';
      })
      bucket.rate_plans.forEach((ratePlan) => {
        ratePlan.rooms_summary.forEach(roomData => {
          if (roomData.room_type_code === roomType) roomData.curr_user_action = checked ? 'recommended_accepted' : '';
        })
      });
    })
    setCheckedVal(checked);

    let isAllRecAccepted = allRatePlanHasRecAccepted(dateRowData.data.buckets);
    let isAnyAltered = isAnyRestrictionsAltered(dateRowData.data.buckets);
    let anyOverridden = anyRatePlanHasOverriden(dateRowData.data.buckets);
    // let isAnyRestrictionOverriden = allRatePlanHasRecAccepted(dateRowData.data.buckets);
    dateRowData.data.isRestrictionsOverridden = anyOverridden;
    if (isAllRecAccepted) {
      dateRowData.data.threshold.curr_user_action = 'recommended_accepted';
      dispatch({
        type: "UPDATE_STATE",
        payload: {
          app_state: {
            plrRowCalcStatus: null,
            plrRecalcDate: null,
          }
        }
      });
    } else if (!isAnyAltered) {
      dateRowData.data.threshold.curr_user_action = '';
      dispatch({
        type: "UPDATE_STATE",
        payload: {
          app_state: {
            plrRowCalcStatus: null,
            plrRecalcDate: null,
          }
        }
      });
    } else {
      dispatch({
        type: "UPDATE_STATE",
        payload: {
          app_state: {
            plrRowCalcStatus: 'active',
            plrRecalcDate: dateRowData.data.date,
          }
        }
      });
    }
    dateRowData.updateRowData(dateRowData.data);
    restrictionsState.updateState({ rowRestrictionsUpdated: roomType + '_' + moment().format("x") });
  }

  useEffect(() => {
    //Take action only when rowRestrictionsUpdated is set and if it is for this roomType
    if (restrictionsState.state.rowRestrictionsUpdated) {
      const roomTypeCode = restrictionsState.state.rowRestrictionsUpdated.split('_')[0];
      if (roomType === roomTypeCode && dateRowData.data.buckets.length) {
        let status = allRatePlanHasRecAccepted(buckets, roomTypeCode);
        setCheckedVal(status);
      }
    }

  }, [restrictionsState.state.rowRestrictionsUpdated]);

  useEffect(() => {
    let isAllRecAccepted = allRatePlanHasRecAccepted(buckets, roomType);
    setCheckedVal(isAllRecAccepted);
  }, []);

  useEffect(() => {
    if (dateRowData.data.threshold.curr_user_action === 'recommended_accepted') {
      setCheckedVal(true);
    } else if (dateRowData.data.threshold.curr_user_action === 'overridden') {
      let isAllRecAccepted = allRatePlanHasRecAccepted(buckets, roomType);
      setCheckedVal(isAllRecAccepted);
    } else {
      setCheckedVal(false);
    }

  }, [dateRowData.data.threshold.curr_user_action]);

  return (
    <Tooltip arrow title={checkedVal ? "" : "Accept all recommendations"}>
      {!isPastDate && <Checkbox
        icon={icons.unCheckedIcon}
        checkedIcon={icons.checkedIcon}
        indeterminateIcon={icons.indeterminateIcon}
        sx={{ p: 0, ml: "2px", mb: "2px", height: "16px", width: "20px" }}
        checked={checkedVal}
        onChange={handleChange}
        disabled={dateRowData.data.processing || dateRowData.data.recalculating}
      />}

      {isPastDate && <Checkbox
        icon={icons.unCheckedIcon}
        checkedIcon={icons.checkedIcon}
        indeterminateIcon={icons.indeterminateIcon}
        sx={{ p: 0, ml: "4px", mb: "2px", height: "15px", width: "15px" }}
        checked={false}
        disabled={true}
      />}

    </Tooltip>
  )
}